import { defineStore } from 'pinia'

export const useCheckoutStore = defineStore('b2bCheckout', () => {
  const ctx = useNuxtApp()
  const client = ctx._apolloClients.default
  const checkout = ref<any>(null)

  const fetchCheckout = async (input) => {
    try {
      const { data } = await client.query({
        query: gql`
          query checkout($input: GetCheckoutInput!) {
            checkout {
              get(input: $input) {
                tariff { id }
                address { autogeneratedUrl }
                b2bLead {
                  userCount
                  orgTypeId
                  orgName
                  orgInn
                  noCompany
                  dadata
                  contactPhone
                  contactLastName
                  contactMiddleName
                  contactName
                }
                provider {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      checkout.value = data?.checkout?.get
    }
    catch (e) {
      console.error('fetchCheckout error', e)
      checkout.value = null
    }
  }
  return { checkout, fetchCheckout }
})
